import { parseDateToString } from '@utils/helpers';
import { omit } from 'lodash';
import { BasketItemType } from 'shared-types/Common';

const multiplicatedItems = ['vouchers', 'events'];

const adaptPersonalizationObject = (personalization) => {
  if (!personalization) {
    return null;
  }

  return {
    ...personalization,
    ...(personalization?.validFrom && { validFrom: parseDateToString(personalization.validFrom) }),
  };
};

export const adaptToBasketItems = (data, type: BasketItemType) => {
  const entityName = type.slice(0, -1);

  const itemIdName = `${entityName}Id`;

  const itemOptionIdName = `${entityName}OptionId`;

  const id = data?.[entityName]?.id;

  // The optionId is used for retail products, as well as vouchers and events
  const optionIdObject = data?.option?.id ? { [itemOptionIdName]: data.option.id } : {};

  const singleItem = {
    ...data,
    ...optionIdObject,
    quantity: parseInt(data.quantity, 10),
    type,
    [itemIdName]: id,
    option: data?.option?.id ? { id: data?.option?.id } : null,
  };

  // 'option' should only be used for retail products in OJ-API
  // Passing for fulfilables will cause a Symfony validation fail in OJ-API
  return [type != 'products' ? omit(singleItem, 'option') : singleItem].flatMap((item) => {
    const isMultiplicated = multiplicatedItems.includes(item.type);

    if (isMultiplicated) {
      return new Array(item.quantity).fill(null).map((_, index) => ({
        ...item,
        personalization: adaptPersonalizationObject(item?.personalization[index]),
        quantity: 1,
      }));
    }
    return [item];
  });
};
